import { createAction } from 'redux-act';

export const DYNAMIC_SET_DATA = createAction('DYNAMIC_SET_DATA');

export const setDynamicData = data => dispatch => {
  return dispatch(DYNAMIC_SET_DATA({ data }));
};
